export default {
  status: {
    airport: '机场',
    aircraft: '飞机',
    rc: '遥控器',
    airportCount: '机场: {count}',
    aircraftCount: '飞机: {count}',
    rcCount: '遥控器: {count}',
  },
  time: {
    month: '月',
    day: '天',
    hour: '小时',
    minute: '分钟',
    second: '秒',
  },
  osd: {
    airport: '机场',
    aircraft: '飞机',
    signalStrength: '信号强度',
    rcBattery: '遥控器电量',
    droneBattery: '飞行器电量',
    rtkFixed: 'RTK 固定',
    gps: 'GPS',
    rtk: 'RTK',
    flightMode: '飞行模式',
    asl: '海拔高度',
    alt: '相对起飞点高度',
    altFromAirport: '相对(机场)起飞点的高度',
    homeDistance: '返航距离',
    horizontalSpeed: '水平速度',
    verticalSpeed: '垂直速度',
    windSpeed: '风速',
    accRuntime: '累计运行时间',
    activationTime: '激活时间',
    networkStatus: '网络状态',
    jobCount: '机场执行任务的总次数',
    mediaRemainUpload: '媒体文件剩余上载',
    airportStorage: '机场存储: {used} / {total}',
    rainfall: '降雨量',
    envTemperature: '环境温度',
    airportTemperature: '机场温度',
    airportHumidity: '机场湿度',
    workingVoltage: '工作电压',
    workingCurrent: '工作电流',
    droneInDock: '机场无人机',
    uploadSignal: '上传信号',
    downloadSignal: '下载信号',
    droneBatteryDock: '无人机电池电量',
    aircraftStorage: '飞机存储: {used} / {total}',
    operate: '操作',
    rainfallLevel: {
      0: '无雨',
      1: '小雨',
      2: '中雨',
      3: '大雨',
    },
  },
}
